import { gql } from 'urql';

const FetchCards = gql`
  query FetchCards($filter: CardsFilter!) {
    cards(filter: $filter) {
      associatedAccountIds
      id
      type
      status
      maskedCardNumber
      isLocked
      isPinSet
      isReplaceable
      associatedAccountIds
      digital
      changePinOptions
      cardHolderName {
        full
      }
      name
      actions
      expiration
    }
  }
`;

export default FetchCards;
